export default "__VITE_ASSET__7c66bb79__"